import { render, staticRenderFns } from "./watermeterSharing.vue?vue&type=template&id=c4068cac&scoped=true"
import script from "./watermeterSharing.vue?vue&type=script&lang=js"
export * from "./watermeterSharing.vue?vue&type=script&lang=js"
import style0 from "./watermeterSharing.vue?vue&type=style&index=0&id=c4068cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4068cac",
  null
  
)

export default component.exports